export default __webpack_public_path__ + "static/media/text_logo.e78fdaa7.svg";